import type { ApiRecordMeasurementsDto } from '@mfw/common';

import { useQueryClient } from '@tanstack/react-query';

import type { RecordMeasurementsResult } from '../../../api/types/stats.types';

import { recordMeasurements } from '../../../api/measurementsStats.api';
import { queryKeys } from '../../../queryKeys';
import { useMutation } from '../../base';

type RecordMeasurementsInput = ApiRecordMeasurementsDto & {
  clientId?: string;
};

export function useRecordMeasurements() {
  const queryClient = useQueryClient();
  const response = useMutation<
    RecordMeasurementsResult | null,
    null,
    RecordMeasurementsInput
  >({
    mutationFn: recordMeasurements,
    onSuccess: () => {
      // writing into the spine affects the daily intake, all query cross-sections, KPI, FS,
      // and the daily nutrition balance (water/caffeine quick-add reads statsNutrition)
      for (const domainKey of [
        queryKeys.statsMeasurements._def,
        queryKeys.statsQuery._def,
        queryKeys.statsKpi._def,
        queryKeys.statsFitnessScore._def,
        queryKeys.statsNutrition._def,
      ]) {
        queryClient.invalidateQueries({ exact: false, queryKey: domainKey });
      }
    },
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
